import { useState } from 'react';
import { Capacitor } from '@capacitor/core';

/**
 * True ONLY when running inside the native Android/iOS app (Capacitor).
 * On the website (any browser) this is always false — so any mobile-only UI
 * gated by this NEVER affects goodjobservice.com.
 *
 * Dev/preview override: set localStorage `gj_preview_native` = '1' to preview
 * the native shell inside a desktop browser. Off by default.
 */
export function isNativeApp() {
  try {
    if (Capacitor && typeof Capacitor.isNativePlatform === 'function' && Capacitor.isNativePlatform()) {
      return true;
    }
  } catch (e) {
    /* noop */
  }
  try {
    if (typeof window !== 'undefined' && window.localStorage.getItem('gj_preview_native') === '1') {
      return true;
    }
  } catch (e) {
    /* noop */
  }
  return false;
}

export function useIsNativeApp() {
  const [native] = useState(() => isNativeApp());
  return native;
}
